import React from "react"
import { Antd, Wrapper, Padder, RichText, } from 'components'
import PropTypes from "prop-types"
import Slider from "react-slick"
import * as S from './styles'
import { isDesktop } from "../../utility"
import Image from '../Image'
import Title from '../Title'
const Icon = Antd.Icon
const Modal = Antd.Modal

const ModalContent = ({ visible, onCancel, title, text, images  }) => {

  return (
    <Modal
      visible={!!visible}
      onCancel={onCancel}
      footer={null}
      centered
      bodyStyle={{padding: '1rem'}}
      width={isDesktop 
        ? (window.innerWidth - 450)
        : (typeof window !== "undefined" ?  (window.innerWidth -32) : 0)}
      height={isDesktop 
        ? (window.innerHeight - 450)
        : (typeof window !== "undefined" ?  (window.innerHeight -32) : 0)}
    >
      <Wrapper size="large">
        <S.ModalInner>
          <Title title={title}>
            <RichText text={text} />
          </Title>
          {images && (
            <Wrapper size="regular">
              <Padder size="regular">
                <Slider {...{
                  dots: true,
                  arrows: true,
                  autoplay: false,
                  nextArrow: <Icon type="right" />,
                  prevArrow: <Icon type="left" />,
                }}>
                  {images.map(image => <Image image={image} />)}
                </Slider>
              </Padder>
            </Wrapper>
          )}
        </S.ModalInner>
      </Wrapper>
    </Modal>
  )
}


ModalContent.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  images:  PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    color: PropTypes.string,
    src: PropTypes.string.isRequired,
  })),
}


export default ModalContent